import React from "react";
import { Search, Tag } from "lucide-react";

interface HistoryFiltersProps {
  searchQuery: string;
  setSearchQuery: (q: string) => void;
  selectedTag: string;
  setSelectedTag: (t: string) => void;
  uniqueTags: string[];
  isEn: boolean;
}

export function HistoryFilters({
  searchQuery,
  setSearchQuery,
  selectedTag,
  setSelectedTag,
  uniqueTags,
  isEn,
}: HistoryFiltersProps) {
  return (
    <div className="mb-4 space-y-2 flex-shrink-0">
      {/* Search Input */}
      <div className="relative w-full">
        <Search className="absolute left-2.5 top-2 text-[var(--text-dim)]" size={12} />
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder={isEn ? "Search..." : "Buscar minutas..."}
          className="w-full bg-[var(--bg3)] border border-[var(--b1)] rounded-[6px] py-1 pl-8 pr-3 text-xs text-[var(--text)] placeholder-[var(--text-dim)] focus:border-[var(--accent)] outline-none"
        />
      </div>

      {/* Tags Select Dropdown */}
      <div className="relative w-full">
        <Tag className="absolute left-2.5 top-2 text-[var(--text-dim)]" size={10} />
        <select
          value={selectedTag}
          onChange={(e) => setSelectedTag(e.target.value)}
          className="w-full bg-[var(--bg3)] border border-[var(--b1)] rounded-[6px] py-1 pl-8 pr-2 text-xs text-[var(--text)] placeholder-[var(--text-dim)] focus:border-[var(--accent)] outline-none cursor-pointer appearance-none"
        >
          <option value="">{isEn ? "All tags" : "Todas las etiquetas"}</option>
          {uniqueTags.map((tag) => (
            <option key={tag} value={tag}>
              {tag}
            </option>
          ))}
        </select>
        {/* Custom arrow for select */}
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-[var(--text-dim)] text-xs">
          ▼
        </div>
      </div>
      {/* <div className="flex justify-end">
        <button
          onClick={() => {
            alert(isEn ? "Tags are created directly within the meeting cards!" : "Las etiquetas se crean directamente desde las tarjetas de las minutas!");
          }}
          className="text-xs font-semibold text-accent hover:underline cursor-pointer px-1 pt-1"
        >
          {isEn ? "+ New tag" : "+ Nueva etiqueta"}
        </button>
      </div> */}
    </div>
  );
}
